import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=8290f438"
import script from "./GroupDetails.vue?vue&type=script&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&lang=ts"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=8290f438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports